var _path, _path2, _path3, _path4, _line, _line2, _line3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-list-check",
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5.5l1.5 1.5l2.5 -2.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11.5l1.5 1.5l2.5 -2.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 17.5l1.5 1.5l2.5 -2.5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 6,
    x2: 20,
    y2: 6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 12,
    x2: 20,
    y2: 12
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 18,
    x2: 20,
    y2: 18
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.bfde10096326b548806511f8f8283f11.svg";
export { ForwardRef as ReactComponent };